import React, { Component } from 'react';
import Icofont from 'react-icofont';
import PropTypes from "prop-types";
import ScrollAnimation from 'react-animate-on-scroll';

class Product extends Component {
    render() {
        return (
            <React.Fragment>
                <section id="product" className="product ptb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 offset-lg-2 text-center">
                                <ScrollAnimation animateIn="fadeInUp">
                                    <div className="section-title">
                                        <h2>{this.props.sectionTitle}</h2>
                                        <p>{this.props.sectionDescription}</p>
                                        <span className="section-title-bg">{this.props.SectionbgTitle}</span>
                                    </div>
                                </ScrollAnimation>
                            </div>
                        </div>
                        <ScrollAnimation animateIn="fadeInUp">
                            <div className="row">
                                <div className="col-md-6 col-lg-6">
                                    <div className="cta-info">
                                        <h2>{this.props.Title}</h2>
                                        <p>{this.props.Content}</p>
                                        <h5>{this.props.Price}</h5><br/>
                                        <div className="center-wrap">
                                            <a href={this.props.BtnLink} rel="noopener noreferrer" target="_blank" className="btn-a">
                                                <div className="button">
                                                    {this.props.BtnName}
                                                    <Icofont icon="icofont-arrow-right" />
                                                    <div className="mask" /></div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6 cta-img">
                                    <img className="img-fluid" src={this.props.Image} alt="mac-pro" />
                                </div>
                            </div>
                        </ScrollAnimation>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

//Props Types
Product.propTypes = {
    SectionbgTitle: PropTypes.string,
    sectionTitle: PropTypes.string,
    sectionDescription: PropTypes.string,
    servicesData: PropTypes.array,
    Title: PropTypes.string,
    Content: PropTypes.string,
    BtnLink: PropTypes.string,
    BtnName: PropTypes.string,
    Image: PropTypes.string,
};

//Default Props
Product.defaultProps = {
    SectionbgTitle: "Products",
    sectionTitle: "高登商品",
    sectionDescription: "現正推出新春期間限定商品，切勿錯過！",
    Title: "爆爆孖腸",
    Content: "時逢佳節，想整返煲臘味飯又或者整返底蘿蔔糕，又點少得臘腸同鵝膶腸？高登記者為大家搜羅本地製作的孖腸，送禮又得自用又得，絕對係過節之選。",
    Price: "售價：$220/盒（原價$280）",
    BtnLink: "https://forms.gle/nYM3hTEh6NFyEe4h7",
    BtnName: "立即訂購",
    Image: require("../assets/img/product-pic.jpg"),
};

export default Product;
